export const defaultBlue: string = '#3E77A5';
export const defaultLightGray: string = '#AAAAAA';
export const defaultDarkGray: string = '#808080';
export const defaultWhite: string = '#FFFFFF'
export const defaultOffWhite: string = '#FFFFFFB2';
export const defaultLightModeTextColor: string = '#8F97A1';
export const defaultDarkModeTextColor: string = '#444444';
export const defaultBlueHighlight: string = '#3E77A533';
export const defaultGrayHighlight: string = '#80808033';
export const transparent: string = "#00000000"